const layout = {
  'layout-header-profile-card-title': 'Profile Settings',
  'layout-header-profile-card-view-profile': 'View Profile',
  'layout-header-profile-card-settings': 'Account Settings',
};

export default layout;
